import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function addEquipmentsToCarnet(equipments, carnetId, prefix, fromXml=false, fromBookshelf=false) {
  const token = await getOrRefreshFirebaseToken();
  
  let endpointUrl;
  if (fromBookshelf) {
    endpointUrl = `${prefix}carnets/${carnetId}/equipments/from_bookshelf`;
  } else if (fromXml) {
    endpointUrl = `${prefix}carnets/${carnetId}/equipments/from_xml`;
  } else {
    endpointUrl = `${prefix}carnets/${carnetId}/equipments`;
  }
  
  const res = await axios.post(
    endpointUrl,
    {
      equipments: equipments, // expects a list of dicts, each with registration_number, piece, maintenance_frequency, last_entretien, etc.
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return res.data;
}